import React from "react"
import ReactModal from "react-modal"
import CloseIcon from "../../../assets/icons/CloseIcon"

import styles from "./index.module.scss"

ReactModal.setAppElement("#root")

const modalSizes = {
  "2xl": 1000,
  xlg: 800,
  lg: 700,
  md: 541,
  sm: 426,
  fullWidth: "100%",
}

const modalContentSizes = {
  "2xl": 900,
  xlg: 650,
  lg: 590,
  md: 461,
  sm: 378,
  fullWidth: "100%",
}

function Header(props) {
  const { children, onClose, bIconClose = true, className, ...rest } = props

  const fnHandleOnClose = (e) => {
    e?.preventDefault()
    e?.stopPropagation()
    onClose?.()
  }

  return (
    <>
      <div className={`${styles.modalHeader} ${className || ""}`} {...rest}>
        <p>{children}</p>
        {bIconClose && (
          <div className={styles.close} onClick={fnHandleOnClose}>
            <CloseIcon fill={"#3B454F"} />
          </div>
        )}
      </div>
    </>
  )
}

function Content(props) {
  const { children, size, ...rest } = props

  const maxWidth = modalContentSizes[size] || "100%"

  return (
    <div className={styles.modalContent} style={{ maxWidth }} {...rest}>
      {children}
    </div>
  )
}

function Footer(props) {
  const { children, size, style, ...rest } = props

  const maxWidth = modalContentSizes[size] || "100%"

  return (
    <div className={styles.modalFooter} style={{ ...style, maxWidth }} {...rest}>
      {children}
    </div>
  )
}

function MainModal(props) {
  const {
    children,
    size = "md",
    nOverlayZindex = 4,
    translateX = "-50%",
    positionLeft = "50%",
    maxHeight = "calc(100vh - 150px)",
    height = "auto",
    minHeight = 250,
    closeOnClickOutside = false,
    customWidth,
    className,
    isOpen,
    bIsFullScreenInMobile = false,
    cOpenAnimation = "default",
    ...rest
  } = props

  const maxWidth = customWidth ? customWidth : modalSizes[size] || modalSizes.md
  const customHeight = size === "fullWidth" && height === "auto" ? "100%" : "auto"
  const customStyles = {
    overlay: {
      background: "rgba(0, 0, 0, 0.4)",
      zIndex: nOverlayZindex,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    content: {
      maxWidth,
      height: customHeight,
      maxHeight: customHeight,
      width: "100%",
      padding: 0,
      border: "none",
      overflow: "hidden",
      borderRadius: 0,
      background: "transparent",
      position: "relative",
      inset: 0,
      outline: "none",
    },
  }

  const elHeader = React.Children.toArray(children)?.find(
    (c) => c?.type?.name === "Header",
  )
  const elChildrens = React.Children.toArray(children)?.filter(
    (c) => c?.type?.name !== "Header",
  )

  const cReactModalOpenClassName = cOpenAnimation === "slideUp" ? styles.slideUp : ""

  return (
    <ReactModal
      style={customStyles}
      shouldCloseOnOverlayClick={closeOnClickOutside}
      shouldCloseOnEsc={false}
      isOpen={isOpen}
      className={isOpen ? `${styles.modalOpen} ${cReactModalOpenClassName}` : ""}
      {...rest}
    >
      <div
        className={`${styles.modalContainer} ${bIsFullScreenInMobile ? styles.mobileFullScreen : ""} ${className || ""}`}
        style={{
          maxHeight: maxHeight,
          height: customHeight,
          minHeight: minHeight,
          borderRadius: size === "fullWidth" ? "0" : "8px",
        }}
      >
        {elHeader}
        <div id="modalOverflowContentContainer" className={styles.modalOverflowContent}>
          <div id="modal-overflow-content" className={styles.modalOverflowContent}>
            {React.Children.map(elChildrens, (elChildren) =>
              React.cloneElement(elChildren, { props, size }),
            )}
          </div>
        </div>
      </div>
    </ReactModal>
  )
}

const Modal = Object.assign(MainModal, { Header, Content, Footer })

export default Modal
